import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Card } from "primereact/card";
import { Image } from "primereact/image";

import background1 from "../../new_Images/OtherComponents/14.png";
import indimg from "../../new_Images/OtherComponents/industry2  (2).png";

import "../../App.css";

function Industry() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Helmet>
        <title>Industries | Clota Technology</title>
        <meta
          name="description"
          content="Explore the industries Clota Technology serves, including educational institutions and banking & finance, delivering custom software and data solutions."
        />
        <meta
          name="keywords"
          content="Industries, Education Software, Finance Software, Clota Technology, Data Services"
        />
                 <meta name="robots" content="index, follow" />
  <meta name="author" content="Clota Technology" />
  <link rel="canonical" href="https://www.clotatech.com/Industry" />
      </Helmet>

      {/* Banner Image */}
      {/* <div className="w-full">
        <img
          src={background1}
          className="w-full homebanner"
          alt="Industries Banner"
        />
      </div> */}

      <div className="banner-container">
        <img src={background1} className="banner-image" alt="Banner" />

        {/* Centered Content */}
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-heading">INDUSTRY</h1>
            
          </div>
        </div>
      </div>

      {/* Heading */}
      <div className="text-center mt-6 mb-4 px-4">
        <h1
          className="Text-Gradient text-3xl md:text-4xl"
          style={{ fontFamily: "rockwell" }}
        >
          <strong>Industries We Work</strong>
        </h1>
      </div>

      <div className="mt-5 px-5 py-2 grid">
        <div className="col-12 md:col-6 flex justify-content-center">
          <img src={indimg} alt="responsiveImage" className="w-10 h-20rem" />
        </div>

        <div className="col-12 md:col-6">
          <h3
            className="mt-5 mb-4 Text-Gradient"
            style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}
          >
            <b><i>Educational Institutions</i></b>
          </h3>
          <p>
            <i>
              Educational Institutions have their core functions to be teaching
              and research. The impact assessment of a university provides
              useful information on the nature and magnitude of its contribution
              to the local communities. Clota Technology are glad to work and help them
              providing software and data services.
            </i>
          </p>
          <br />

          <h3
            className="mt-5 mb-4 Text-Gradient"
            style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}
          >
            <b><i>Banking And Finance</i></b>
          </h3>
          <p>
            <i>
              Through enterprise architecture, consultancy, and integrated
              services, Clota Technology offer next-generation application lifecycle
              management. We oversee and improve the technological foundation
              that generates commercial results. We enable improved customer
              experience across all touchpoints.
            </i>
          </p>
        </div>
      </div>

      {/* 
      <div className="flex justify-content-center mb-4">
        <Image
          src={indimg}
          alt="Industries Overview"
          className="industryimage1 border-round"
        />
      </div>

      <div className="grid justify-content-center px-4 mb-6">
        <div className="col-12 md:col-3">
          <Card className="h-full text-center surface-card">
            <h4
              className="Text-Gradient mb-3"
              style={{ fontFamily: "rockwell" }}
            >
              <b>
                <i>Educational Institutions</i>
              </b>
            </h4>
            <p>
              <i>
                Educational Institutions have their core functions to be
                teaching and research. The impact assessment of a university
                provides useful information on the nature and magnitude of its
                contribution to the local communities. We are glad to work and
                help them providing software and data services.
              </i>
            </p>
          </Card>
        </div>

        <div className="col-12 md:col-3">
          <Card className="h-full text-center surface-card ">
            <h4
              className="Text-Gradient mb-3"
              style={{ fontFamily: "rockwell" }}
            >
              <b>
                <i>Banking And Finance</i>
              </b>
            </h4>
            <p>
              <i>
                Through enterprise architecture, consultancy, and integrated
                services, we offer next-generation application lifecycle
                management. We oversee and improve the technological foundation
                that generates commercial results. We enable improved customer
                experience across all touchpoints.
              </i>
            </p>
          </Card>
        </div>
      </div> */}
    </>
  );
}

export default Industry;
